import { render, staticRenderFns } from "./Select2.vue?vue&type=template&id=1c50d76a&"
import script from "./Select2.vue?vue&type=script&lang=ts&"
export * from "./Select2.vue?vue&type=script&lang=ts&"
import style0 from "./Select2.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Select2.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports